








import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'

export default Vue.extend({
  name: 'QrDialog',
  components: { QrcodeVue },
  props: {
    qrDialogOpened: Boolean,
    imei: String
  },
  data () {
    return {
      showQr: false
    }
  },
  methods: {
    close () {
      this.$emit('closeInfoGuideDialog')
    }
  },
  watch: {
    qrDialogOpened (val) {
      this.showQr = val
    }
  }
})
